import { useEffect, useState } from "react";
import { _CompetitionType, _DocumentFactory, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _IncomeCompensationDocument } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { FileService } from "../../../../core/services/FileService";
import usePaginator from "../../../theme/Component/usePaginator";
import { DocumentStateTypes } from "./DocumentStateTypes";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../theme/Component/DropDown";

interface Props {
    income:any;
}


export const IncomeCompensationAccount = ({ income }: Props) => {

    const IncomeCompensationDocument = useDataBean(_IncomeCompensationDocument);       
    const [docs, setDocs] = useState<any>([]);    
    const _documentos = useDataBean(_DocumentFactory);
    const [registro, setregistro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });        
    const paginador2 = usePaginator();    
    const [listaTercer, setListaTercero] = useState<any>([]);
        
    useEffect(() => {
        getPaymentHeaderCredit();
    }, [income,paginador2.page])

    useEffect(() => {
        if (registro.view) {
            verDocumentos();
        }
    }, [registro.view]);
   


    const head = [
        { title: 'ID', property: 'IDIncomeCompensationDocument', visible: true },
        { title: 'Tercero Compensado', property: 'TerceroID', visible: true },
        { title: 'Documento', property: 'Doc', visible: true },
        { title: 'Fecha de Documento', property: 'DocumentDate', visible: true },
        { title: 'Estado Documento', property: 'DocumentStateName', visible: true },
        { title: 'Cuenta Contable Compensada', property: 'AccountantIDName', visible: true },
        { title: 'Valor', property: 'Value', visible: true },
        { title: 'No Crédito', property: 'LoanNumber', visible: true },
        { title: 'No Cuota', property: 'IDLoanQuota', visible: true },
        { title: 'Archivo de Carga Masiva', property: 'URL', visible: true },
        { title: 'Titular Crédito', property: 'Titular', visible: true },
        { title: 'No Proceso', property: 'Proceess', visible: true },
        { title: 'Funcionario', property: 'Employee', visible: true },


    ];
    const headTercero = [
        { title: 'Nit', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Names', visible: true },
        { title: 'Apellidos', property: 'Surnames', visible: true },
        { title: 'No Crédito', property: 'LoanNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Valor', property: 'LoanQuotaPaidedValue', visible: true, mask: MASK_MONEY },
        { title: 'Nemonico', property: 'FCMnemonic', visible: true },
        { title: 'Consecutivo', property: 'FCConsecutive', visible: true, mask: MASK_NUMBER },
    ];

    
    const listaBotones = () => {
        const botones = [

            { titulo: "Ver Documento", icono: "ri-file-list-line", visible: true, evento: () => { setregistro({ ...registro, "view": true }) }, },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const verDocumentos = () => {

        if (IncomeCompensationDocument.bean.FCIDDocument) {
            _documentos.instance.getPdfAccountantDocument(IncomeCompensationDocument.bean.FCIDDocument, null, IncomeCompensationDocument.bean.FCDate, _single.getAccountID()).then(
                (resp: any) => {                    
                    setDocs(resp.DocumentURL);
                    setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }

    const getPaymentHeaderCredit = () => {

        const b: any = { ...income };
        if (b.IDDocument) {
            let filter = {
                IADMnemonic: b.Mnemonic,
                IADIDDocument: b.IDDocument,
                IADConsecutive: b.Consecutive
            }
            IncomeCompensationDocument.instance.getPaymentHeaderCredit(paginador2.page, 15, filter, _single.getCurrenYear()).then(
                (resp: any) => {
                    setListaTercero(resp.List);
                    paginador2.setPages(resp.NumberOfPages);
                    paginador2.setRecords(resp.NumberOfPages * (15));
                    paginador2.setRegiPerPage(15)
                }
            )

        }


    }
   

    return (
        <div className="row">
           
           <div className="col-md-12">
            <h6>{income.Description}</h6>
           </div>
            <div className="col-md-12">
                <BasicTable  body={listaTercer} head={headTercero} rowSet={IncomeCompensationDocument.setBean} listButtons={listaBotones()}
                    pageTop={paginador2.page} next={paginador2.next} back={paginador2.back} records={paginador2} customRows={15}></BasicTable>
                <Modal modal={registro} updateModal={setregistro}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={IncomeCompensationDocument.bean.IDDocument}
                                Since={IncomeCompensationDocument.bean.DocumentDate}
                            />
                        </div>
                    </div>
                </Modal>
               

            </div>
            {/* <div className="col-md-12">
                <PrintJson json={income}/>
            </div> */}

        </div>
    )
}